<script lang="ts">
    import { Pagination as PaginationPrimitive } from "bits-ui";
    import ChevronRightIcon from "@lucide/svelte/icons/chevron-right";
    import { buttonVariants } from "../../../components/ui/button/index.js";
    import { cn } from "../../../utils.js";
    import { m } from "../../../messages.svelte.js";

    let {
        ref = $bindable(null),
        class: className,
        children,
        ...restProps
    }: PaginationPrimitive.NextButtonProps = $props();
</script>

{#snippet Fallback()}
    <span>{m["Next"]()}</span>
    <ChevronRightIcon class="size-4" />
{/snippet}

<PaginationPrimitive.NextButton
    bind:ref
    aria-label="Go to next page"
    class={cn(
        buttonVariants({
            size: "default",
            variant: "ghost",
            class: "gap-1 px-2.5 sm:pr-2.5",
        }),
        className,
    )}
    children={children || Fallback}
    {...restProps}
/>
